import { PageType, SubmissionType } from "components/server-types";
import { ActivityWithPagesType, selectAssessedSubmissionsByTopicId } from "store/selectors";
import { useListSelector } from "store/store-hooks";

export const useCanDeleteActions = (topicId: string, pages?: PageType[]) => {
  const assessedSubmissions = useListSelector((s) =>
    selectAssessedSubmissionsByTopicId(s, topicId),
  );
  const assessedSubmissionsByPageId: { [key: string]: SubmissionType } = {};
  for (const submission of assessedSubmissions) {
    assessedSubmissionsByPageId[submission.page_id] = submission;
  }

  const assessedPagesByActivityId: { [key: string]: PageType } = {};
  if (pages) {
    for (const page of pages) {
      if (page.activity_id && assessedSubmissionsByPageId[page.id]) {
        assessedPagesByActivityId[page.activity_id] = page;
      }
    }
  }

  return {
    canDeleteActivity: (targetActivity: ActivityWithPagesType) =>
      !assessedPagesByActivityId[targetActivity.id],
    canDeleteTopic: !assessedSubmissions.length,
  };
};
